import { apiUc } from '../http';
import ServiceCRUD from './ServiceCRUDFLEXUC';

class VoiceChannelsService extends ServiceCRUD {
  constructor() {
    super('/api/voice-channels');
  }

  findById = (id) => {
    return apiUc.get(`${this.path}/${id}`);
  };

  create = (data) => {
    return apiUc.post(this.path, data);
  };

  update = (id, data) => {
    return apiUc.put(`${this.path}/${id}`, data);
  };

  delete = (id) => {
    return apiUc.delete(`${this.path}/${id}`);
  };

  list = (page = 1, limit = 10, query = '') => {
    const offset = (page - 1) * limit;

    const config = {
      params: {
        q: query,
        limit: limit,
        offset: offset
      }
    };
    return apiUc.get(this.path, config);
  };
}

export default new VoiceChannelsService();
